/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef } from "react";
import Content from "../../../../../layout/content/Content";
import {
    Spinner, Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";
import loadspinner from "../../../../../assets/images/spinner.gif"
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
    BlockDes,
    BlockHead, PaginationComponent
} from "../../../../../components/Component";
import Head from "../../../../../layout/head/Head";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionS from "../../../../components/DynmicOption/OptionS";
import MultipleQuater from "../../../../components/DynmicOption/multiplequarter";
import FinancialYear from "../../../../components/DynmicOption/FinancialYear";
import Swal from 'sweetalert2'
import FinancialYearReport from "../../../../components/DynmicOption/FinancialYearReport";
import MultipleQuaterNew from "../../../../components/DynmicOption/multiplequarterNew";

const CP1MisReport = ({ ...props }) => {
    const itemPerPage = 2000
    const [currentPage, setCurrentPage] = useState(1);
    const [Statee, setStatee] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([])
    const [Selected, setSelected] = useState([])
    const [load, setload] = useState(false);
    const month1 = ["Q4 (Jan - Mar)", "Q4 (Jan - Mar)", "FEBRUARY", "MARCH", "Q1 (Apr - Jun)", "MAY", "JUNE", "Q2 (Jul - Sep)", "AUGUST", "SEPTEMBER", "Q3 (Oct - Dec)", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const tableRef = useRef(null);
    const tableRef1 = useRef(null);
    const [DataCount, setDataCount] = useState(0)
    const [generate1, setgenerate1] = useState(true);
    const [gen, setgen] = useState(0);
    const loading = false
    const [nextloading, setnextloading] = useState(false);
    const [loadmain, setloadmain] = useState(true);
    const [modal, setmodal] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYearCP") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYearCP"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() + 1 : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth() + 1] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentFinancialYearTosame") === null ? null : sessionStorage.getItem("CurrentFinancialYearTosame"),
        EmploymentRefId: 1,
        state: -1,
        
    })
    const [selectedYear, setSelectedYear] = useState("")
    const paginate = (pageNumber) => {
        setnextloading(true)
        setStatee([])
        var mainid = document.getElementById("datashow")
        mainid.scrollIntoView();
        //console.log(mainid);
      
        setCurrentPage(pageNumber)

        if (formData.state !== String(0)) { getdata3(pageNumber) } else { getdataAll(pageNumber) }
        
       
    };
    const [states, setstates] = useState("")
    const onInputChange = (e) => {
        var index = e.nativeEvent.target.selectedIndex
         setstates(e.nativeEvent.target[index].text)
        setFormData({ ...formData, [e.target.name]: e.target.value })
        
        
    };
    
    const onInputChange2 = (year) => {
       // sessionStorage.setItem("CurrentFinancialYearTosame", year)
        setFormData({ ...formData, toyear: year })
    }
    const getdata3 = async (pageno) => {
        const sendData = {
            EmploymentRefId: Number(13),
            UserId: Number(formData.state),
            YearId: Number(formData.toyear),
            AllMonth: selectedOptions,
            Take: Number(itemPerPage),
            Skip: Number((pageno - 1) * itemPerPage)
        }
        //console.log("SendData", sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/CP1MIS', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log("Cp1_Mis_report", data)
                    setStatee(data)
                    if (data.length === 0) {
                        setmodal(false)

                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)
                    
                  
                })


    }

    const getdatacount = async () => {
        const sendData = {
            EmploymentRefId: Number(13),
            UserId: Number(formData.state),
            YearId: Number(formData.toyear),
            AllMonth: selectedOptions
        }
         //console.log("Count_sendData", sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/CP1MISCOUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //  console.log("Count", data)
                    setDataCount(data)

                })


    }

    const getdatacountAll = async () => {
        const sendData = {
            EmploymentRefId: Number(13),
            YearId: Number(formData.toyear),
            AllMonth: selectedOptions,
            UserId: Number(0)

        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/CP1MISAllCOUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   // console.log("Count", data)
                    setDataCount(data)

                })


    }

    const getdataAll = async (page) => {
        const sendData = {
            EmploymentRefId: Number(13),
            UserId: Number(0),
            YearId: Number(formData.toyear),
            AllMonth: selectedOptions,
            Take: Number(itemPerPage),
            Skip: Number((page - 1) * itemPerPage)
        }
        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/CP1MISAll', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   // console.log(data)
                    setStatee(data)
                    if (data.length === 0) {
                        setmodal(false)

                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)



                })


    }

    const generate = async () => {
        
        setgen(gen +1)
        setloadmain(false)
        setmodal(true)
        setload(false)
        getdata3(1)
        getdatacount()
        setgenerate1(false)

      

    }

    const generateAll = async () => {
        
        setgen(gen +1)
        setloadmain(false)
        setmodal(true)
        setload(false)
        getdatacountAll()
        getdataAll(1)
        setgenerate1(false)

      

    }

    const genawal = () => {
        Swal.fire({
            title: "Required Fields Not Selected",
            text: "Oops! Please select the State, Financial Year, and Quarter to generate the report.",
            icon: "error"
        })
    }
    const TableRow = React.memo(({ details, itemPerPage, currentPage, month1, index }) => {
        return (
            <tr key={index}>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {(itemPerPage * (currentPage - 1)) + index + 1}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.yearId} - {Number(details.yearId) + 1}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{month1[details.monthId]}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.statename}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.center}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.nameoftheemployer1 === null ? "--" : details.nameoftheemployer1}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.designationofposts2 === null ? "--" : details.designationofposts2}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.group3 === null ? "--" : details.group3}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.level4 === null ? "--" : details.level4}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.fieldBranch5 === null ? "--" : details.fieldBranch5}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.qualification6 === null ? "--" : details.qualification6}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.experience7 === null ? "--" : details.experience7}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.noofvacancies8 === null ? "--" : details.noofvacancies8}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.employercategory9 === null ? "--" : details.employercategory9}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.nameofthestate10 === null ? "--" : details.nameofthestate10}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {details.jobname11 === null ? "--" : details.jobname11}
                </td>
                
                

            </tr>
        );
    })

    /*console.log("seletedpton", formData.state)*/
    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <BlockHead size="lg">

                            <BlockDes className="text-soft">
                                
                                    <td >
                                        <h5 style={{ color: '#798bff', marginBottom:60 }}>CP1 MIS REPORT</h5>
                                    </td>
                                
                                <Row className="align-items-center justify-content-between">
                                    <Col xs="1">
                                        <label style={{ color: 'black', fontSize: 15 }}>
                                            State : 
                                            <label style={{ fontWeight: 'bold', marginLeft: 3 }}>
                                                <OptionS
                                                    catid="43"
                                                    onInputChange={onInputChange}
                                                    namemain="state"
                                                    mainid="state"
                                                />
                                            </label>
                                        </label>
                                    </Col>
                                    <Col xs="1">
                                        <label style={{ color: 'black', fontSize: 15 }}>
                                            Financial Year :
                                            <label style={{ fontWeight: 'bold', marginLeft:3 }}>
                                                <FinancialYearReport
                                                    defaultValuemain={`${formData.toyear !== null ? `${formData.toyear}-${Number(formData.toyear) + 1}` : "SELECT"}`}
                                                    catid="42"
                                                    onInputChange={onInputChange2}
                                                    namemain="year"
                                                    mainid="year"
                                                />
                                            </label>
                                        </label>
                                    </Col>
                                    <Col xs="8" className="mb-1">
                                        <label style={{ color: 'black', fontSize: 15 }}>
                                            Quaters :
                                            <label style={{ fontWeight: 'bold', marginLeft: 3 }}>
                                                <MultipleQuaterNew
                                                    setSelectedOptions={setSelectedOptions}
                                                    selectedOptions={selectedOptions}
                                                />
                                            </label>
                                        </label>
                                       
                                           
                                    </Col>
                                    <Col xs="2" className="mb-1 ">
                                        <label style={{ color: 'black', fontSize: 15 }}>
                                            
                                            <label style={{ fontWeight: 'bold'}}>
                                                {formData.state >= 0 && formData.toyear && selectedOptions.length > 0 ? (
                                                    formData.state !== String(0) ? (
                                                        <Button color="success" onClick={() => generate()}>
                                                            Generate
                                                        </Button>
                                                    ) : (
                                                        <Button color="success" onClick={() => generateAll()}>
                                                            Generate
                                                        </Button>
                                                    )
                                                ) : (
                                                    <Button color="danger" onClick={() => genawal()}>
                                                        Generate
                                                    </Button>
                                                )}
                                            </label>
                                        </label>
                                        
                                    </Col>
                                </Row>

                            </BlockDes>
                        </BlockHead>
                                <hr />

                        <Modal isOpen={false} fullscreen="xl" size="xl" >
                            <ModalBody>
                                
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br/>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <img src={loadspinner} alt="load" />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={() => window.location.reload()}>
                                    Stop Report
                                </Button>{' '}

                            </ModalFooter>
                        </Modal>

                            {generate1? <h3>Please Select State, Financial Year and Quarter to Generate Report!!</h3> : 
                            <>
                                {modal ? <div>
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Spinner size="xl" />
                                    </div>
                                </div> : null}
                                <div style={{ visibility: modal ? "hidden" :"visible" }}>
                                <Row>
                                <Col xl="3" md="3">
                                    <h4 style={{ marginBottom: 40 }}>Employment Report (CP1) </h4>
                                </Col>
                               <Col xl="3" md="3">
                                   
                                        </Col>
                                        <Col xl="3" md="3">
                                    
                                    </Col>

                                    {loadmain?
                                        <Col xl="3" md="3">
                                            <Button disabled style={{ float: "right" }} color="danger" ><Icon className="icon ni ni-download"></Icon>Export Excel</Button>

                                        </Col> :

                                        <Col xl="3" md="3">
                                            <DownloadTableExcel
                                                filename="CP1 Report"
                                                sheet="users"
                                                currentTableRef={tableRef.current}
                                            >
                                                <Button style={{ float: "right" }} color="info" ><Icon className="icon ni ni-download"></Icon>Export Excel</Button>
                                            </DownloadTableExcel>
                                        </Col>}
                               
                                </Row>

                                    <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                            <table className="table table-orders" ref={tableRef1} style={{ borderCollapse: "separate", borderSpacing: 0, border: '1px solid black' }}>
                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0 }}>


                                    <tr> <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                        Description

                                    </th>
                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                            Abbreviation

                                        </th>
                                        <br />
                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                            Description

                                        </th>
                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                            Abbreviation

                                        </th>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Gender</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Jobseekers on the live Register at the end of previous month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >LR_PM</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Male</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >M</td>

                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "200px" }} >Total number of registration during the month ( includes regisration cards received on transfer + fresh registration + re-registration made during the month)</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", alignItems: "center" }} >REG</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Female</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >F</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >No. of Jobseekers placed during the month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >P</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Transgender</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >TR</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Registration removed from Live Register during the month* ( includes regisrtation card removed from Live Register for reason other than Transfer to other exchanges and regisration cards transferred to other exchanges during the month)</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Rem</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Total</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >G_TOT</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Jobseekers remaining on the Live Register at the end of month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >LR_CM</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Category</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Submissions made during the month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SUB</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Caste</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SC</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Total vacancies notified during the month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >NOTIFIED</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Tribe</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ST</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Vacancies filled during the month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >FILLED</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Minorities Communities</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Muslim</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >MUS</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Christians</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >CHR</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Sikhs</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SIKH</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Budhists</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >BUDH</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Zoarastrians</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ZO</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Total</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >MCO_TOT</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Muslim</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >MUS</td>
                                    </tr>

                                </thead>

                            </table>

                                    </div>


                                    <div className="card-inner-group" style={{ border: '4px solid black', padding: 2 }}>
                                        <div style={{ height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                            <span id="datashow" style={{ visibility: "hidden", height: 0, width: 0 }}></span>
                                            <table className="table " ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0, counterReset: "Serial" }}>
                                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                        <tr>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                Form: CP1 Report

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                State: {states}

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                Financial Year: {formData.toyear} - {Number(formData.toyear) + 1}

                                                            </th>
                                                        </tr>
                                                    </thead>
                                                </div>

                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                    <tr>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "100px" }} >
                                                            S. No.

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "100px" }} >
                                                            Fin Year

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "150px" }} >
                                                            Quarter

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "150px" }} >
                                                            State
                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Employment Exchange

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "250px" }} >
                                                            Name of the Employer/ Organization Name

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Designation of Posts

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Group

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Level

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Field & Branch

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Qualification

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Experience

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            No. of Vacancies

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Employer Category

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Name of the States/UT

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Job Nature

                                                        </th>
                                                        

                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            According to 7th Pay Commission

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, color: "black", backgroundColor: 'orange', verticalAlign: 'inherit' }} >
                                                            Required specific field*(attached sheet Field & Branch Code )
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, color: "black", backgroundColor: 'orange', verticalAlign: 'inherit' }} >
                                                            Required 8th/10th/12th/Diploma/ Graduate/PostGraduate/ PhD

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, color: "black", backgroundColor: 'orange', verticalAlign: 'inherit' }} >
                                                            With /Without experience

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, color: "black", backgroundColor: 'orange', verticalAlign: 'inherit' }} >
                                                            CG- Central Govt. SG- State Govt. QG- Quasi Govt. LB- Local Bodies PV- Private Sector


                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, color:"black", backgroundColor: 'orange', verticalAlign: 'inherit' }} >
                                                            whether Regular/ Temporary/ Contractual/ Deputation

                                                        </th>

                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <td id="datashow" style={{ visibility: "hidden", height: 0, width: 0 }}></td>
                                                    {nextloading ? (
                                                        <tr>
                                                            <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                                                <div>
                                                                    <h3>Please wait while the report is loading...</h3>
                                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Spinner size="xl" />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : load ? (
                                                        Statee.length !== 0 && nextloading === false ? (
                                                            Statee.map((details, index) => (
                                                                <TableRow
                                                                    key={index}
                                                                    details={details}
                                                                    itemPerPage={itemPerPage}
                                                                    currentPage={currentPage}
                                                                    month1={month1}
                                                                    index={index}
                                                                />
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" style={{ textAlign: 'center' }}>
                                                                    <h3>No Data Found</h3>
                                                                </td>
                                                            </tr>
                                                        )
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" style={{ textAlign: 'center' }}>
                                                                <Spinner color="success" />
                                                            </td>
                                                        </tr>
                                                    )}


                                                </tbody>
                                            </table>

                                        </div>



                                    </div>

                             </div>
                                {Statee.length > 0 && (
                                    <PaginationComponent
                                        noDown
                                        itemPerPage={itemPerPage}
                                        totalItems={DataCount}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                        EmploymentRefId={13}
                                        UserId={formData.state}
                                        MonthId={formData.month}
                                        YearId={formData.year}
                                        ToYearId={formData.toyear}
                                        ToMonthId={formData.tomonth}
                                        setStatee={setStatee}
                                        setmodal={setmodal}
                                        setload={setload}
                                    />
                                )}
                            </>
                        }

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default CP1MisReport;
